var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositivacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/positiva\xC3\xA7\xC3\xA3o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "positiva\xC3\xA7\xC3\xA3o",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28887 4.83637L11.2564 0.745455L10.4699 0L7.28887 3.27273L5.62844 1.47273L4.82445 2.29091L7.28887 4.83637ZM3.09363 15.6143C3.33833 15.8714 3.63422 16 3.98131 16C4.32839 16 4.62552 15.8727 4.8727 15.6182C5.11986 15.3636 5.24345 15.0558 5.24345 14.6948C5.24345 14.3337 5.1211 14.0246 4.8764 13.7675C4.63171 13.5104 4.33582 13.3818 3.98872 13.3818C3.64164 13.3818 3.34451 13.5091 3.09734 13.7636C2.85017 14.0182 2.72659 14.326 2.72659 14.6871C2.72659 15.0481 2.84894 15.3572 3.09363 15.6143ZM10.1548 15.6143C10.3995 15.8714 10.6954 16 11.0425 16C11.3896 16 11.6867 15.8727 11.9339 15.6182C12.181 15.3636 12.3046 15.0558 12.3046 14.6948C12.3046 14.3337 12.1823 14.0246 11.9376 13.7675C11.6929 13.5104 11.397 13.3818 11.0499 13.3818C10.7028 13.3818 10.4057 13.5091 10.1585 13.7636C9.91135 14.0182 9.78777 14.326 9.78777 14.6871C9.78777 15.0481 9.91011 15.3572 10.1548 15.6143ZM0 1.45454L0 2.54545H1.3633L3.95006 8.43636L2.83146 10.5818C2.63338 10.9576 2.64892 11.3273 2.87809 11.6909C3.10728 12.0545 3.4413 12.2364 3.88015 12.2364H12.3046V11.1455H3.72285L4.70162 9.25454H9.9975C10.2408 9.25454 10.4648 9.18484 10.6694 9.04545C10.874 8.90606 11.0404 8.72121 11.1685 8.4909L14 2.98181H12.829L10.0273 8.07272H4.99875L2.02747 1.45454L0 1.45454Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositivacao);
export default __webpack_public_path__ + "static/media/positivacao.b5741154.svg";
export { ForwardRef as ReactComponent };